import { Injectable, ElementRef } from '@angular/core';
import * as moment_ from 'moment'; const moment = moment_
import { OverlayPositionBuilder, ConnectedPosition, OverlayRef, Overlay } from '@angular/cdk/overlay';
import { DatePickerLocale } from './public-api';
import { DATE_FORMAT, TIME_FORMAT } from './date-picker-const';

@Injectable({
    providedIn: 'root'
})
export class NpDatePickerService {

    public get locale(): DatePickerLocale {
        return moment.locale() as DatePickerLocale;
    }

    constructor(private overlayPositionBuilder: OverlayPositionBuilder,
        private overlay: Overlay) { }

    /**
     * æ ¹æ®ä¼ å¥çmomentæ¶é´åä¼ å¥çå¹´ä»½çæå¹´ä»½èå´æ°ç»YearDataã
     * ä¾å¦ï¼year = 2020ï¼ å¹´ä»½èå´valueç¤ºä¾ä¸º
     * 
     * [
     * 
     *      2019, 2020, 2021, 
     * 
     *      2022, 2023, 2024, 
     * 
     *      2025, 2026, 2027, 
     * 
     *      2028, 2029, 2030
     * 
     * ]
     * @param date Momentæ¶é´
     * @param year å¹´ä»½YYYYï¼ ä¾ï¼2020
     * @param selectedDate å½åéä¸­çæ¥æ
     */
    buildYearsPanel(date: moment_.Moment, year: string, selectedDate: moment_.Moment): Array<YearData> {
        let years: Array<YearData> = [];

        let lastNumOfYear: number = +year.charAt(3);
        let start = lastNumOfYear;
        let end = 10 - lastNumOfYear;

        let copyDateStart = date.clone();
        while (start >= 0) {
            const cur = copyDateStart.add(-1, 'year');
            years.push({
                available: start > 0,
                value: cur.format('YYYY'),
                isSelected: selectedDate ? selectedDate.format('YYYY') === cur.format('YYYY') : false,
                date: cur.clone()
            });
            start--;
        }

        years.push({
            available: true,
            value: date.format('YYYY'),
            isSelected: selectedDate ? selectedDate.format('YYYY') === date.format('YYYY') : false,
            date: date.clone()
        });

        let copyDateEnd = date.clone();
        while (end <= 10 && end > 0) {
            const cur = copyDateEnd.add(1, 'year');
            years.push({
                available: end > 1,
                value: cur.format('YYYY'),
                isSelected: selectedDate ? selectedDate.format('YYYY') === cur.format('YYYY') : false,
                date: cur.clone()
            });
            end--;
        }

        return years.sort((a, b) => { return (+a.value - +b.value); });
    }

    /**
     * æå»ºå½åå¹´ä»½çå¨é¨æä»½
     * @param selectedDate å½åéä¸­çæ¥æ
     */
    buildMonthsPanel(date: moment_.Moment, selectedDate: moment_.Moment): Array<MonthData> {
        let m = moment.monthsShort();
        let months: Array<MonthData> = [];
        for (let i = 0; i < m.length; i++) {
            months.push({
                available: true,
                value: m[i],
                isSelected: selectedDate ? m[i] === selectedDate.format('MMM') : false,
                date: moment(date.format('YYYY') + m[i] + date.format('DD'), 'YYYYMMMDD')
            })
        }

        return months;
    }

    /**
     * æ ¹æ®ä¼ å¥çæ¥ææå»ºå½åæ¾ç¤ºæ¥åé¢æ¿ï¼å½åè¿ä¸ªæçå¤©æ°é¢æ¿ï¼ã
     * ä¾å¦ï¼ä¼ å¥æ¥æä¸º2020/08/20ï¼åè¿åä¸ä¸ªDayDataPerMonthæ°ç»ï¼
     * å¶ä¸­çvalueç¤ºä¾å¦ä¸:
     * 
     * ['æ¥', 'ä¸', 'äº', 'ä¸', 'å', 'äº', 'å­', 
     * 
     *  '26', '27', '28', '29', '30', '31', '1', 
     * 
     *  '2',  '3',  '4',  '5',  '6',  '7',  '8',
     * 
     *  '9',  '10', '11', '12', '13', '14', '15',
     * 
     *  '16', '17', '18', '19', '20', '21', '22',
     * 
     *  '23', '24', '25', '26', '27', '28', '29',
     * 
     *  '30', '31',  '1',  '2',  '3',  '4',  '5']
     * @param date æå»ºæ¥æé¢æ¿çæ¥æ
     * @param selectedDate å½åéä¸­çæ¥æ
     * @param isRangePicker æ¯å¦æ¯æ¶é´åºé´éæ©
     * @param dates å½isRangePickerä¸ºtrueæ¶ï¼éè¦ä¼ å¥æ­¤æ¶é´åºé´å­æ®µï¼ä»£è¡¨æ¶é´åºé´å·²éæ©çåºé´å¼
     */
    buildDaysPanel(date: moment_.Moment, selectedDate: moment_.Moment): Array<DayDataPerMonth> {
        const total = 49;
        let days: Array<DayDataPerMonth> = [];
        let copyDate = date.clone();
        let weekdaysMin = this.getWeekdaysMin();
        weekdaysMin.forEach(item => {
            days.push({ available: false, value: item, isSelected: false, isWeekDayMin: true, date: null });
        });

        let startOfMonth = copyDate.clone().startOf('month');
        startOfMonth = moment(startOfMonth.format(DATE_FORMAT) + ' ' + copyDate.format(TIME_FORMAT));
        // è·åå½æç¬¬ä¸å¤©æ¯å¨å ï¼å¦2020/08/01æ¯å¨å­ï¼åå¾å°çæ¯âå­â
        let weekDayMin_startOfMonth = weekdaysMin[+startOfMonth.weekday() + 1];
        let index_weekDayMin_startOfMonth = weekdaysMin.indexOf(weekDayMin_startOfMonth);
        // æ·»å ä¸æåå å¤©ç¨ä»¥è¡¥è¶³å½åé¢æ¿
        while (index_weekDayMin_startOfMonth > 0) {
            days.push({
                available: false,
                value: startOfMonth.clone().add(-index_weekDayMin_startOfMonth, 'day').format('D'),
                isSelected: false,
                isWeekDayMin: false,
                date: startOfMonth.clone().add(-index_weekDayMin_startOfMonth, 'day').clone()
            });
            index_weekDayMin_startOfMonth--;
        }

        let lastOfMonth = copyDate.clone().endOf('month');
        lastOfMonth = moment(lastOfMonth.format(DATE_FORMAT) + ' ' + copyDate.format(TIME_FORMAT));
        // è·åå½ææåå¤©æ¯å¨å ï¼å¦2020/08/31æ¯å¨ä¸ï¼åå¾å°çæ¯âä¸â
        // æ·»å å½æå°å½åé¢æ¿æ°ç»
        while (startOfMonth <= lastOfMonth) {
            days.push({
                available: true,
                value: startOfMonth.format('D'),
                isSelected: selectedDate ? startOfMonth.format(DATE_FORMAT) === selectedDate.format(DATE_FORMAT) : false,
                isWeekDayMin: false,
                date: startOfMonth.clone()
            });
            startOfMonth = startOfMonth.add(1, 'day');
        }

        // æ·»å ä¸æåå å¤©ç¨ä»¥è¡¥è¶³å½åé¢æ¿
        let i = 1;
        while (days.length < total) {
            days.push({
                available: false,
                value: lastOfMonth.clone().add(i, 'day').format('D'),
                isSelected: false,
                isWeekDayMin: false,
                date: lastOfMonth.clone().add(i, 'day').clone()
            });
            i++;
        }

        return days;
    }

    sortDates(dates: Array<moment_.Moment>, asc: boolean = true) {
        return dates.sort((a, b) => asc ? a.diff(b) : b.diff(a));
    }

    buildStartAndEndDates(sDate: moment_.Moment, eDate: moment_.Moment) {
        if (!sDate || !eDate) {
            return [];
        }

        if (moment(sDate) < moment(eDate)) {
            return [sDate, eDate];
        }

        return [eDate, sDate];
    }

    day(date: moment_.Moment) {
        if (date) {
            return moment(date.format(DATE_FORMAT + ' 00:00:00'), 'YYYY-MM-DD');
        }

        return moment();
    }

    private getDayStatus(currentDate: moment_.Moment, hoverDate: moment_.Moment, dates: Array<moment_.Moment> = []): DayStatusForRangePicker {
        if (!dates || dates.length === 0) {
            return 'normal';
        }

        const day = (date: moment_.Moment) => {
            if (date) {
                return moment(date.format(DATE_FORMAT + ' 00:00:00'), 'YYYY-MM-DD');
            }

            return moment();
        }

        let sortedDates = this.sortDates([hoverDate, ...dates]);
        if (currentDate < sortedDates[0] || currentDate > sortedDates[2]) {
            return 'normal' as DayStatusForRangePicker;
        }

        if (day(hoverDate).diff(dates[0]) < 0) {
            if (day(currentDate).diff(day(hoverDate)) < 0) {
                return 'normal';
            } else if (day(currentDate).diff(hoverDate) >= 0 && day(currentDate).diff(dates[0]) < 0) {
                return 'within-hover';
            } else if (day(currentDate).diff(dates[0]) >= 0 && day(currentDate).diff(dates[1]) <= 0) {
                return 'within-selected';
            } else if (day(currentDate).diff(dates[1]) > 0) {
                return 'normal';
            }
        }

        if (day(hoverDate).diff(dates[0]) >= 0 && day(hoverDate).diff(dates[1]) <= 0) {
            if (day(currentDate).diff(day(dates[0])) < 0) {
                return 'normal';
            } else if (day(currentDate).diff(dates[0]) >= 0 && day(currentDate).diff(hoverDate) < 0) {
                return 'within-selected-hover';
            } else if (day(currentDate).diff(hoverDate) >= 0 && day(currentDate).diff(dates[1]) <= 0) {
                return 'within-selected';
            } else if (day(currentDate).diff(dates[1]) > 0) {
                return 'normal';
            }
        }

        if (day(hoverDate).diff(dates[1]) > 0) {
            if (day(currentDate).diff(day(dates[0])) < 0) {
                return 'normal';
            } else if (day(currentDate).diff(dates[0]) >= 0 && day(currentDate).diff(dates[1]) < 0) {
                return 'within-selected';
            } else if (day(currentDate).diff(dates[1]) >= 0 && day(currentDate).diff(hoverDate) <= 0) {
                return 'within-hover';
            } else if (day(currentDate).diff(hoverDate) > 0) {
                return 'normal';
            }
        }

        return 'normal' as DayStatusForRangePicker;
    }

    /**
     * æå»ºæ¶é´åºé´éæ©å½é¼ æ hoveré¢æ¿æ¶çç¶æï¼åbuildDaysPanelçåè½ï¼
     * å¢å å¯¹è±¡DayDataPerMonthä¸­å¯¹å­æ®µisWithinDateRangeHoverçå¼çåºåã
     * 
     * @param date æå»ºæ¥æé¢æ¿çæ¥æ
     * @param selectedDate å½åéä¸­çæ¥æ
     * @param hoverDate å½åhoverçæ¶é´momentå¼
     * @param dates éè¦ä¼ å¥æ­¤æ¶é´åºé´å­æ®µï¼ä»£è¡¨æ¶é´åºé´å·²éæ©çåºé´å¼
     */
    buildDaysPanelForRangePicker(date: moment_.Moment, selectedDate: moment_.Moment,
        hoverDate: moment_.Moment, dates: Array<moment_.Moment> = []) {
        const total = 49;
        let days: Array<DayDataPerMonth> = [];
        let copyDate = date.clone();
        let weekdaysMin = this.getWeekdaysMin();
        weekdaysMin.forEach(item => {
            days.push({ available: false, value: item, isSelected: false, isWeekDayMin: true, date: null, hoverDateType: 'normal' });
        });

        let startOfMonth = copyDate.clone().startOf('month');
        startOfMonth = moment(startOfMonth.format(DATE_FORMAT) + ' ' + copyDate.format(TIME_FORMAT));
        // è·åå½æç¬¬ä¸å¤©æ¯å¨å ï¼å¦2020/08/01æ¯å¨å­ï¼åå¾å°çæ¯âå­â
        let weekDayMin_startOfMonth = weekdaysMin[+startOfMonth.weekday() + 1];
        let index_weekDayMin_startOfMonth = weekdaysMin.indexOf(weekDayMin_startOfMonth);
        // æ·»å ä¸æåå å¤©ç¨ä»¥è¡¥è¶³å½åé¢æ¿
        while (index_weekDayMin_startOfMonth > 0) {
            let cDate = startOfMonth.clone().add(-index_weekDayMin_startOfMonth, 'day').clone();
            days.push({
                available: false,
                value: cDate.format('D'),
                isSelected: false,
                isWeekDayMin: false,
                date: cDate,
                hoverDateType: this.getDayStatus(cDate, hoverDate, dates)
            });
            index_weekDayMin_startOfMonth--;
        }

        let lastOfMonth = copyDate.clone().endOf('month');
        lastOfMonth = moment(lastOfMonth.format(DATE_FORMAT) + ' ' + copyDate.format(TIME_FORMAT));
        // è·åå½ææåå¤©æ¯å¨å ï¼å¦2020/08/31æ¯å¨ä¸ï¼åå¾å°çæ¯âä¸â
        // æ·»å å½æå°å½åé¢æ¿æ°ç»
        while (startOfMonth <= lastOfMonth) {
            days.push({
                available: true,
                value: startOfMonth.format('D'),
                isSelected: selectedDate ? startOfMonth.format(DATE_FORMAT) === selectedDate.format(DATE_FORMAT) : false,
                isWeekDayMin: false,
                date: startOfMonth.clone(),
                hoverDateType: this.getDayStatus(startOfMonth.clone(), hoverDate, dates)
            });
            startOfMonth = startOfMonth.add(1, 'day');
        }

        // æ·»å ä¸æåå å¤©ç¨ä»¥è¡¥è¶³å½åé¢æ¿
        let i = 1;
        while (days.length < total) {
            let cDate = lastOfMonth.clone().add(i, 'day').clone();
            days.push({
                available: false,
                value: cDate.format('D'),
                isSelected: false,
                isWeekDayMin: false,
                date: cDate.clone(),
                hoverDateType: this.getDayStatus(cDate, hoverDate, dates)
            });
            i++;
        }

        return days;
    }

    getWeekdaysMin() {
        return moment.weekdaysMin();
    }

    getOverlayRef(elementRef: ElementRef): OverlayRef {
        const popupPositions: ConnectedPosition[] = [{
            originX: "start",
            originY: "bottom",
            overlayX: "start",
            overlayY: "top",
            offsetX: 0,
            offsetY: 1
        }, {
            originX: "start",
            originY: "top",
            overlayX: "start",
            overlayY: "bottom",
            offsetX: 0,
            offsetY: -1
        }];

        const positionStrategy = this.overlayPositionBuilder
            .flexibleConnectedTo(elementRef)
            .withPositions(popupPositions);


        return this.overlay.create({
            positionStrategy,
            hasBackdrop: true,
            backdropClass: 'cdk-overlay-transparent-backdrop',
            scrollStrategy: this.overlay.scrollStrategies.noop()
        });
    }

    /**è·åcalendaræ¶é´ï¼ä¾å¦ä»å¤©ï¼æ¨å¤©ï¼æå¤©ç­ */
    calendar(date: moment_.Moment, locale: DatePickerLocale = 'zh-cn') {
        let calendarDate = '';
        switch (locale) {
            case 'zh-cn':
                calendarDate = date.calendar({
                    sameDay: '[ä»å¤©]',
                    nextDay: '[æå¤©]',
                    nextWeek: 'dddd',
                    lastDay: '[æ¨å¤©]',
                    lastWeek: '[ä¸] dddd',
                    sameElse: 'DD/MM/YYYY'
                });
                break;
            case 'en':
                calendarDate = date.calendar({
                    sameDay: '[Today]',
                    nextDay: '[Tomorrow]',
                    nextWeek: 'dddd',
                    lastDay: '[Yesterday]',
                    lastWeek: '[Last] dddd',
                    sameElse: 'DD/MM/YYYY'
                });
                break;
            default:
                calendarDate = date.calendar({
                    sameDay: '[ä»å¤©]',
                    nextDay: '[æå¤©]',
                    nextWeek: 'dddd',
                    lastDay: '[æ¨å¤©]',
                    lastWeek: '[ä¸] dddd',
                    sameElse: 'DD/MM/YYYY'
                });
                break;
        }

        return calendarDate;
    }

    isValid(date: moment_.Moment | string) {
        return date && moment(date).isValid();
    }
}

export interface DateData {
    /**æ¯å¦å¯é */
    available: boolean;
    /**å½åå¼ */
    value: string;
    /**å½åæ¯å¦éä¸­ */
    isSelected: boolean;
    /**å½åæ¥æ */
    date: moment_.Moment;
}

export interface DayDataPerMonth extends DateData {
    /**æ¯å¦æ¯ç¬¬ä¸è¡çå¨ */
    isWeekDayMin: boolean;
    /**å½datepickertypeä¸ºdate-range-pickerçæ¶åï¼é¼ æ hoveråå¨åéæ¶é´åºé´çåä¸ºtrueï¼å¦åfalse */
    hoverDateType?: DayStatusForRangePicker;
}

/**
 * åºé´æ¶é´éæ©å¨æææ¥æå¤©æ°é¢æ¿çç¶æåå¯¹åºæ ·å¼
 * 
 * normal - æ­£å¸¸æ¥æå¤©æ° æ é¢å¤æ ·å¼
 * 
 * within-hover - å¨hoverçæ¶é´åºé´éé¢ æèçº¿è¾¹æ¡
 * 
 * within-selected - å¨å·²éçæ¶é´åºé´éé¢ æèæ¯è²
 * 
 * within-selected-hover - å¨å·²éçæ¶é´åºé´éé¢è¢«hover å æ·±èæ¯è²
 */
export type DayStatusForRangePicker = 'normal' | 'within-hover' | 'within-selected' | 'within-selected-hover';

export interface YearData extends DateData { }

export interface MonthData extends DateData { }